export default __webpack_public_path__ + "static/media/rail-cleaners.b28806fc.webp";